import { useState } from "react";
import { FileUploader } from "react-drag-drop-files";
import {
  Box,
  Button,
  CircularProgress,
  TextField,
  Typography,
} from "@mui/material";

import BackButton from "../components/BackButton";
import { useAuth } from "../contexts/AuthContext";
import { centerAlignItems } from "../utils/styles";
import { useSnackbar } from "../contexts/SnackbarProvider";

const CUBook = ({ onBack, book }) => {
  const IS_CREATE = book ? false : true;
  const Auth = useAuth();
  const { setSnackbarDetail } = useSnackbar();
  const [file, setFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  function addBook(e) {
    e.preventDefault();
    setIsLoading(true);
    let formData = new FormData();

    if (IS_CREATE || e.target.title.value) {
      formData.append("title", e.target.title.value);
    }

    if (IS_CREATE || e.target.bg.value) {
      formData.append("bgColor", e.target.bg.value);
    }

    if (IS_CREATE || file) {
      formData.append("image", file);
    }

    Auth.AuthenticatedServerCall({
      method: IS_CREATE ? "POST" : "PATCH",
      isFormData: true,
      body: formData,
      entity: `api/books${IS_CREATE ? "" : "/" + book?.id}`,
    })
      .then((res) => {
        setSnackbarDetail({
          open: true,
          message: res.message,
          severity: "success",
        });
        e.target.reset();
        setFile();
        setIsLoading(false);
      })
      .catch((error) => {
        setSnackbarDetail({
          open: true,
          message: error.message,
          severity: "error",
        });
        setIsLoading(false);
      });
  }

  return (
    <Box
      component="form"
      onSubmit={addBook}
      sx={centerAlignItems}
      className="md-CUBook"
    >
      <BackButton onBack={onBack} />
      <TextField
        sx={{ m: 1, minWidth: "400px" }}
        label="title"
        id="title"
        required
        defaultValue={IS_CREATE ? "" : book?.title}
      />
      <TextField
        sx={{ m: 1, minWidth: "400px" }}
        type="color"
        label="background-color"
        id="bg"
        required
        defaultValue={IS_CREATE ? "" : book?.title}
      />
      <FileUploader
        handleChange={(img) => setFile(img)}
        name="file"
        types={["JPG", "PNG", "JPEG"]}
      />
      {file?.name && (
        <Typography gutterBottom variant="caption">
          {file.name}
        </Typography>
      )}

      <Button
        type="submit"
        variant="contained"
        sx={{ m: 2 }}
        disabled={isLoading}
      >
        {isLoading ? <CircularProgress size={22} /> : "save"}
      </Button>
    </Box>
  );
};

export default CUBook;
